import React from 'react'
import PropTypes from 'prop-types'
import { Link, withAssetPrefix } from 'gatsby'
import base from '../../components/base.css'
import old from '../../components/old.css'

import styled from 'styled-components'
import Container from '../../components/Container'
import Navigation from '../../components/Navigation'
import Search from '../../components/Search'
import {Flex, Box} from 'reflexbox/styled-components'

const StyledA = styled.a`
  text-decoration: none;
`

const StyledLink = styled(Link)`
  text-decoration: none;
`

class Layout extends React.Component {
  render() {
    const { children } = this.props
    let header

    let rootPath = `/`
    if (typeof __PREFIX_PATHS__ !== `undefined` && __PREFIX_PATHS__) {
      rootPath = __PATH_PREFIX__ + `/`
    }

    return (
      <Container>
        <Flex
          style={{ margin: `0 auto` }}
          alignItems="center"
          maxWidth="800px"
          justifyContent="space-between"
          py={3}
        >
          <Navigation />
          <Flex>
            <Box mr={4}>
              <StyledLink to="/">Blog</StyledLink>
            </Box>
            <Box mr={4}>
              <StyledA href="http://share.shoekicker.com/">
                Win free shoes
              </StyledA>
            </Box>
          </Flex>
          <Search />
        </Flex>
        {children}
        <script src={withAssetPrefix('/gleam.js')} />
        <script
          dangerouslySetInnerHTML={{
            __html: `
            !function(e,t) {"use strict"; if("#gleam"==window.location.hash||!(""+document.cookie).match(/(^|;)\s*Gleamg7XBJ=X($|;)/)){var o=e.createElement(t),a=e.getElementsByTagName(t)[0];o.src="https://js.gleam.io/g7XBJ/ol.js",a.parentNode.insertBefore(o,a)}}(document,"script");
          `,
          }}
        />
      </Container>
    )
  }
}

Layout.propTypes = {
  children: PropTypes.node,
}

export default Layout
